// NavigationContext.js
import React, { createContext, useState, useCallback } from 'react';

export const NavigationContext = createContext({
  breadcrumbs: [],
  setBreadcrumbs: () => {},
});

export const NavigationProvider = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  const updateBreadcrumbs = useCallback((newCrumbs) => {
    setBreadcrumbs(newCrumbs);
  }, []);

  return (
    <NavigationContext.Provider value={{ breadcrumbs, updateBreadcrumbs }}>
      {children}
    </NavigationContext.Provider>
  );
};
